import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import '@polymer/paper-styles/color.js';
import '@polymer/paper-styles/shadow.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@polymer/iron-list/iron-list.js';
import '@polymer/paper-item/paper-item.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-item/paper-item-body.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '@polymer/iron-media-query/iron-media-query.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import '../katapult-elements/katapult-button.js';
import '../style-modules/katapult-scrollbars';
import { ToArray } from '../../modules/ToArray.js';
import { GeoStyleToIcon } from '../../modules/GeoStyleToIcon.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { Clamp } from '../../modules/Clamp.js';
import { GetFixedPosition, GetFixedPositionCallback } from '../../modules/GetFixedPosition.js';
import { KatapultPicker } from '../../mixins/katapult-picker';
/**
 * `pole-application-list`
 * List element for displaying pole application poles
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
/* global Polymer, k, CustomEvent */
class KatapultDropDown extends KatapultPicker(PolymerElement) {
  static get template() {
    return html`
      <style include="katapult-scrollbars">
        :host {
          position: relative;
          display: flex;
          align-items: center;

          --katapult-drop-down-font-size: 12pt;
          --katapult-drop-down-item-font-size: 12pt;
          --katapult-drop-down-slot-font-size: 11pt;
          --katapult-drop-down-color: transparent;

          --mobile-list-margin: 24px;
          --border-radius: 8px;

          --katapult-drop-down-clear-button-color: var(--katapult-drop-down-input-color, var(--primary-text-color));
        }

        :host([no-underline]) #input {
          --paper-input-container-underline: {
            display: none;
          }
          --paper-input-container-underline-focus: {
            display: none;
          }
          --paper-input-container-underline-disabled: {
            display: none;
          }
        }

        input::-ms-clear {
          display: none;
        }

        #inputWrapper {
          display: flex;
          align-items: center;
          flex-grow: 1;
        }
        #inputWrapper[overlay=''] {
          position: fixed;
          top: var(--mobile-list-margin);
          left: var(--mobile-list-margin);
          width: calc(100% - (2 * var(--mobile-list-margin)));
          padding: 4px 8px;
          box-sizing: border-box;
          z-index: 1000;
          background-color: white;
          border-top-left-radius: var(--border-radius);
          border-top-right-radius: var(--border-radius);
        }
        #input {
          box-sizing: border-box;
          outline: none;
          border: none;
          border-radius: 0;
          flex-grow: 1;
          background-color: var(--katapult-drop-down-color);
          --paper-input-container-input: {
            font-size: var(--katapult-drop-down-font-size);
            color: var(--katapult-drop-down-input-color, var(--primary-text-color));
          };
          --paper-input-container-label: {
            font-size: var(--katapult-drop-down-font-size);
          };
          @apply (--katapult-drop-down-input);
        }
        ::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          @apply (--katapult-drop-down-placeholder);
        }
        #input > iron-icon,
        #input > katapult-button {
          padding: 0;
          margin: 0;
          height: 24px;
          width: 24px;
        }
        #input > katapult-button[icon='clear'] {
          padding-bottom: 4px;
          @apply --katapult-drop-down-clear-button;
        }
        #input > iron-icon[icon='arrow-drop-down'] {
          color: var(--katapult-drop-down-arrow-color, var(--secondary-color, var(--primary-color)));
        }
        #input[readonly] {
          --paper-input-container-input: {
            opacity: 0.8;
          };
          --paper-input-container-underline: {
            border-bottom: 1px dashed gray;
          };
          --paper-input-container-underline-focus: {
            border-bottom: 1px dashed gray;
          };
        }
        #list {
          position: fixed;
          border-radius: var(--border-radius);
          z-index: 1000;
          overflow-x: hidden;
          overflow-y: hidden;
          background-color: white;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          max-height: 100%;
          width: 300px;
          @apply --katapult-drop-down-list;
          @apply --shadow-elevation-4dp;
        }
        #list[overlay=''] {
          position: fixed;
          top: 96px;
          left: var(--mobile-list-margin);
          width: calc(100% - (2 * var(--mobile-list-margin)));
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }

        paper-item {
          --paper-item: {
            font-size: var(--katapult-drop-down-item-font-size, 12pt);
            padding: 8px 12px;
          };
        }

        #backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #000;
          opacity: 0;
          transition: opacity 0.2s;
          pointer-events: none;
          z-index: 999;
        }

        #backdrop[overlay=''] {
          opacity: 0.6;
          pointer-events: auto;
        }
        #slotContent {
          display: flex;
          flex-shrink: 0;
          border-top: 1px solid var(--paper-grey-300);
          margin-top: -1px; /* Covers duplicate border */
          @apply --slot-content;
        }
        #slotContent ::slotted(paper-item),
        .option {
          background-color: white;
          cursor: default;
          white-space: nowrap;
          @apply (--list-item);
        }
        #slotContent ::slotted(paper-item) {
          color: var(--primary-text-color-faded);
          text-transform: uppercase;
          font-size: var(--katapult-drop-down-slot-font-size);
          /* font-weight: bolder; */
          flex-grow: 1;
          justify-content: center;
          @apply --slotted-paper-item;
        }
        #slotContent ::slotted(paper-item:not(:last-of-type)) {
          border-right: 1px solid var(--paper-grey-300);
        }
        #slotContent ::slotted(paper-item:hover),
        .row[highlight=''] {
          background-color: var(--secondary-color, var(--primary-color));
          cursor: pointer;
          color: var(--secondary-color-text-color, var(--primary-color-text-color));
        }
        .row[selected=''] {
          font-weight: bold;
        }
        iron-icon {
          margin: 0 4px;
          color: var(--katapult-drop-down-icon-color, var(--paper-grey-700));
        }
        .row {
          border-bottom: 1px solid var(--paper-grey-300);
          @apply (--list-item);
        }
        .row:last-of-type {
          border-bottom: none;
        }
        .row > span {
          overflow: hidden;
          text-overflow: ellipsis;
        }
        #ironList {
          flex-grow: 1;
        }
        .icon {
          flex-shrink: 0;
          color: var(--primary-text-color-faded);
        }
        .iconContainer {
          width: 24px;
          height: 24px;
          padding: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .secondaryLabel {
          white-space: normal;
          font-size: 10pt;
          color: var(--primary-text-color-faded);
        }
        .row[highlight=''] .icon,
        .row[highlight=''] .secondaryLabel {
          color: var(--primary-color-text-color-faded);
        }
      </style>
      <iron-a11y-keys keys="enter" on-keys-pressed="enterPressed"></iron-a11y-keys>
      <iron-a11y-keys keys="up down tab" on-keys-pressed="arrowPressed"></iron-a11y-keys>
      <iron-a11y-keys keys="esc" on-keys-pressed="close"></iron-a11y-keys>

      <div id="inputWrapper" overlay$="[[overlay]]">
        <paper-input
          id="input"
          on-mousedown="inputMouseDownHandler"
          on-focus="inputFocusHandler"
          on-keydown="inputKeyDownHandler"
          title="[[fullSearchText]]"
          value="{{searchText}}"
          label="[[label]]"
          disabled="{{disabled}}"
          readonly$="{{readonly}}"
          invalid="{{invalid}}"
          error-message="{{errorMessage}}"
          auto-validate="[[autoValidate]]"
          no-label-float="[[noLabelFloat]]"
        >
          <div slot="prefix" style$="[[prefixStyle]]"><slot name="prefix"></slot></div>
          <template is="dom-if" if="[[!disabled]]">
            <template is="dom-if" if="[[!readonly]]">
              <template is="dom-if" if="[[!showClearButton]]">
                <iron-icon icon="arrow-drop-down" slot="suffix"></iron-icon>
              </template>
              <template is="dom-if" if="[[showClearButton]]">
                <katapult-button
                  icon="clear"
                  iconOnly
                  noBorder
                  on-mousedown="preventDefault"
                  on-click="clear"
                  slot="suffix"
                  textColor="var(--katapult-drop-down-clear-button-color)"
                ></katapult-button>
              </template>
            </template>
          </template>
        </paper-input>
      </div>
      <iron-collapse opened="[[opened]]" no-animation="">
        <div id="list" style$="[[listStyle]]" overlay$="[[overlay]]">
          <div id="aboveListSlot"><slot name="aboveList"></slot></div>
          <iron-list id="ironList" items="[[filteredSortedItems]]" on-dom-change="ironListItemsChanged">
            <template>
              <paper-item
                class="row"
                highlight$="[[equal(index, highlightIndex)]]"
                selected$="[[matchesValue(item, value)]]"
                item="[[item]]"
                value="[[getValue(item)]]"
                on-click="clickItem"
                on-contextmenu="openContextMenu"
                on-mouseover="hoverItem"
                tabindex="-1"
              >
                <paper-item-body>
                  <div class="primaryLabel" style="width: fit-content; max-width: -webkit-fill-available;">
                    [[getLabel(item, labelPath, labelFunction)]]
                  </div>
                  <template is="dom-if" if="[[secondaryLabelPath]]">
                    <div class="secondaryLabel">[[getSecondaryLabel(item, secondaryLabelPath, secondaryLabelFunction)]]</div>
                  </template>
                </paper-item-body>
                <template is="dom-repeat" items="[[item.icons]]" as="icon">
                  <div class="iconContainer" style$="[[getIconContainerStyle(icon)]]" on-click="clickIcon">
                    <iron-icon
                      id="icon[[index]]"
                      class="icon"
                      style$="[[getIconStyle(icon)]]"
                      icon="[[getIcon(icon)]]"
                      src="[[getIconSrc(icon)]]"
                      title$="[[icon.tooltip]]"
                    ></iron-icon>
                  </div>
                </template>
              </paper-item>
            </template>
          </iron-list>
          <div id="slotContent" on-mouseover="removeHoverItem"><slot></slot></div>
        </div>
      </iron-collapse>
      <div id="backdrop" overlay$="[[overlay]]" on-click="close"></div>
    `;
  }

  static get is() {
    return 'katapult-drop-down';
  }
  static get properties() {
    return {
      /* Focus when attached */
      autoFocus: {
        type: Boolean,
        value: false
      },
      autoValidate: {
        type: Boolean,
        value: false
      },
      attributeName: {
        type: String,
        notify: true
      },
      clientWidth: {
        observer: 'clientWidthChanged'
      },
      disabled: {
        type: Boolean,
        value: false,
        notify: true,
        reflectToAttribute: true
      },
      displayShortname: {
        type: Boolean,
        value: false
      },
      readonly: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      firebaseKey: {
        type: String,
        value: 'firebaseKey',
        notify: true
      },
      filteredSortedItems: {
        type: Array,
        value: () => [],
        notify: true
      },
      fixedListPosition: {
        type: Object,
        value: () => ({})
      },
      ironListItemsHeight: {
        type: Number,
        value: 0
      },
      hideEmptyListValue: {
        type: Boolean,
        value: false
      },
      hideForSearchLength: {
        type: Boolean,
        computed: 'computeHideForSearchLength(minSearchLength, searchText)'
      },
      highlightIndex: {
        type: Number,
        value: 0,
        observer: 'highlightIndexChanged'
      },
      icon: {
        type: String,
        value: null
      },
      keepOpen: {
        type: Boolean,
        value: false
      },
      label: {
        type: String,
        value: ''
      },
      listHeight: {
        type: Number,
        value: null
      },
      listStyle: {
        type: String
      },
      log: {
        type: Boolean,
        value: false
      },
      margin: {
        type: Number,
        value: 24
      },
      headerHeight: {
        type: Number,
        value: 50
      },
      minSearchLength: {
        type: Number,
        value: 0
      },
      /* force mobile view */
      mobile: {
        type: Boolean,
        value: false
      },
      noClear: {
        type: Boolean,
        value: false
      },
      noLabelFloat: {
        type: Boolean,
        value: false
      },
      /* force non-mobile view */
      noMobileView: {
        type: Boolean,
        value: false
      },
      nullValue: {
        type: Object,
        value: '',
        notify: true
      },
      isMobile: {
        type: Boolean,
        computed: 'calcIsMobile(mobile, noMobileView)'
      },
      invalid: {
        type: Boolean,
        value: false
      },
      showClearButton: {
        type: Boolean,
        value: false,
        computed: 'calcShowClearButton(searchText, noClear)'
      },
      showAllItems: {
        type: Boolean,
        value: false
      },
      errorMessage: {
        type: String,
        value: ''
      },
      search: {
        type: Function,
        value: null
      },
      searchText: {
        type: String,
        value: '',
        notify: true
      },
      selectOnFocus: {
        type: Boolean,
        value: false
      },
      showLastResults: {
        type: Boolean,
        value: false
      },
      showValueAsLabel: {
        type: Boolean,
        value: false
      },
      sort: {
        type: Function,
        value: null
      },
      sortAlphabetically: {
        type: Boolean,
        value: false
      },
      onlyOpenDown: {
        type: Boolean,
        value: false
      },
      opened: {
        type: Boolean,
        value: false,
        notify: true,
        observer: 'openedChanged'
      },
      overlay: {
        type: Boolean,
        value: false,
        computed: 'calcOverlay(isMobile, opened)',
        reflectToAttribute: true,
        notify: true
      },
      verticalOffset: {
        type: Number,
        value: 0
      },
      prefixStyle: {
        type: String,
        value: ''
      }
    };
  }
  static get observers() {
    return [
      'updateListDirection(ironListItemsHeight)',
      'updateFilteredSortedItems(itemsArray, searchText, sort, sortAlphabetically)',
      'updateListStyle(listHeight, openUpwards, hideForSearchLength, isMobile, keyboardVisible, fixedListPosition.*, verticalOffset)',
      'resizeIronList(filteredSortedItems.length)',
      'ironListItemsChanged(filteredSortedItems.*)',
      'filteredSortedItemsChanged(filteredSortedItems, filteredSortedItems.splices)',
      'resetHighlightIndex(searchText, opened)'
    ];
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    window.removeEventListener('resize', this.windowResizeHandler, { passive: true });
    window.removeEventListener('mousedown', this.boundClose, { passive: true });
    window.removeEventListener('popstate', this.windowPopStateHandler, { passive: true });
  }
  ready() {
    super.ready();
    this.uuid = ('d' + Math.random()).split('.')[1];
    this.boundClose = function (e) {
      if (!e.data || e.data.uuid !== this.uuid) this.close();
    }.bind(this);
    this.boundUpdateListStyle = this.updateListStyle.bind(this);
    this.windowResizeHandler = function () {
      this.updateListDirection();
      this.updateListStyle();
    }.bind(this);
    this.windowPopStateHandler = function (e) {
      if (this.ignoreNextPopState) this.ignoreNextPopState = false;
      else this.close();
    }.bind(this);
    this.mouseDownHandler = (e) => {
      e.data = e.data || {};
      e.data.uuid = this.uuid;
    };
    this.stopPropagation = (e) => e.stopPropagation();
    this.clickHander = (e) => {
      if (!this.disabled) {
        e.preventDefault();
        e.stopPropagation();
      }
      // this.focusInput();
    };

    this.addEventListener('mousedown', this.mouseDownHandler, { passive: true });
    this.addEventListener('wheel', this.stopPropagation, { passive: true });
    this.addEventListener('click', this.clickHandler);

    if (this.autoFocus) {
      setTimeout(() => {
        this.focus();
      }, 100);
    }
  }
  and() {
    return Array.from(arguments).every((x) => x);
  }

  updateItemsArray() {
    this.itemsArray = ToArray(this.items);
  }
  calcShowClearButton(searchText, noClear) {
    return searchText && !noClear;
  }
  computeHideForSearchLength(minSearchLength, searchText) {
    return minSearchLength > (searchText || '').length;
  }
  calcIsMobile() {
    return (this.mobile || (typeof self.isMobile !== 'undefined' && self.isMobile)) && !this.noMobileView;
  }
  calcOverlay() {
    return this.isMobile && this.opened;
  }
  equal(a, b) {
    return a === b;
  }
  filteredSortedItemsChanged(e) {
    this.dispatchEvent(new CustomEvent('list-changed', e));
  }
  focus() {
    this.open();
    this.focusInput();
  }
  focusInput() {
    if (!this.$.input.focused) this.$.input.focus();
  }
  getIconSrc(icon) {
    // Check if the icon looks like an object with geostyle data
    if (icon.i || icon.si) {
      // Get the svg and replace
      let iconData = GeoStyleToIcon(icon);
      if (iconData) {
        let svg = iconData.url.replace('data:image/svg+xml,', '');
        // Put the # back in the SVG
        svg = svg.replace(/\%23/g, '#');
        // Convert to blob and then to image URL
        let blob = new Blob([svg], { type: 'image/svg+xml' });
        return URL.createObjectURL(blob);
      }
    }
  }
  getIcon(icon) {
    // Check if the icon is an object with an icon property or a string. This
    // is because now the icon object can contain geostyle data and should instead
    // be processed by the getIconSrc function
    if (icon && typeof icon == 'object' && icon.icon) return icon.icon;
    else if (typeof icon === 'string') return icon;
  }
  getIconStyle(icon) {
    let style = '';
    if (icon) {
      // Check if the icon data looks like geostyle data
      if (icon.i || icon.is) {
        let iconData = GeoStyleToIcon(icon);
        if (iconData) {
          if (icon.s)
            style += `--iron-icon-height:${iconData.size.height}px !important;--iron-icon-width:${iconData.size.width}px !important;`;
          if (icon.c) style += `color:${icon.c};`;
          if (icon.s) style += `height:${iconData.size.height}px;width:${iconData.size.width}px;`;
        }
      } else {
        if (icon.iconSize) style += `--iron-icon-height:${icon.iconSize}px !important;--iron-icon-width:${icon.iconSize}px !important;`;
        if (icon.color) style += `color:${icon.color};`;
        if (icon.size) style += `height:${icon.size}px;width:${icon.size}px;`;
        if (icon.margin != null) style += `padding:${icon.margin}px;`;
      }
    }
    return style;
  }
  getIconContainerStyle(icon) {
    let style = '';
    if (icon != null) {
      if (icon.containerPadding != null) style += `padding:${icon.containerPadding}px;`;
      if (icon.containerMargin != null) style += `margin:${icon.containerMargin}px;`;
    }
    return style;
  }
  clickIcon(e) {
    this.dispatchEvent(new CustomEvent('icon-click', { detail: { originalEvent: e, item: e.model?.parentModel?.item } }));
  }
  inputFocusHandler(e) {
    // If the element is disabled, do nothing
    if (this.disabled) return;
    // If we are not on a mobile device, then select the value
    if (!this.isMobile) {
      this.$.input.$.nativeInput.select();
    }
    // Quit if the element is readonly
    if (this.readonly) return;
    this.dispatchEvent(new CustomEvent('input-focus', e));
  }
  inputKeyDownHandler(e) {}
  inputMouseDownHandler(e) {
    // Quit if the element is disabled or readonly
    if (this.disabled || this.readonly) return;
    // Update list height to know if list is overflowing or not.
    this.updateListDirection();
    // Prevent input from taking focus on drop down first being opened if on mobile.
    if (e.target.tagName === 'PAPER-INPUT' && this.isMobile && !this.overflow && !this.$.input.focused) e.preventDefault();
    if (this.isMobile) this.focus();
    else this.open();
  }
  matchesValue(item, value) {
    return this.getValue(item) == value;
  }
  highlightIndexChanged() {
    if (this.skipHighlightScroll) {
      this.skipHighlightScroll = false;
      return;
    }
    // Make sure highlight item is not out of sight.
    if (this.highlightIndex)
      this.$.ironList.scrollTop = Clamp(
        this.$.ironList.scrollTop,
        (this.highlightIndex + 1) * 48 - this.listHeight + this.$.slotContent.offsetHeight + this.$.aboveListSlot.offsetHeight,
        this.highlightIndex * 48
      );
  }
  resizeIronList() {
    if (this.opened) this.$.ironList.notifyResize();
  }
  ironListItemsChanged(e) {
    let secondaryLabelCount = 0;
    for (let i = 0; i < this.filteredSortedItems.length; i++) {
      if (!!this.secondaryLabelPath == true && this.filteredSortedItems[i][this.secondaryLabelPath]) secondaryLabelCount++;
    }
    const normalRowHeight = 48;
    const labelAdder = 17; // Add 17 pixels to the height of the row for the label
    this.ironListItemsHeight = (this.get('filteredSortedItems.length') || 0) * normalRowHeight + secondaryLabelCount * labelAdder;
  }
  setSelectedItem(item, options = {}) {
    super.setSelectedItem(item, options);
    if (!this.keepOpen && !this.$.input.focused) this.updateSearchText();
  }
  clickItem(e) {
    this.setSelectedItem(e.currentTarget.item);
    this.close();
  }
  openContextMenu(e) {
    // Dispatch a contextmenu event to the parent element
    this.dispatchEvent(new CustomEvent('contextmenu', { detail: { originalEvent: e, item: e.model.item }, bubbles: true, composed: true }));
  }
  hoverItem(e) {
    this.skipHighlightScroll = true;
    this.highlightIndex = e.model.index;
    const primaryLabel = e?.currentTarget?.querySelector('.primaryLabel');
    if (primaryLabel) {
      if (primaryLabel.scrollWidth > primaryLabel.clientWidth) {
        primaryLabel.title = this.getLabel(e.model.item);
      }
    }
  }
  removeHoverItem(e) {
    this.highlightIndex = null;
  }
  updateListStyle() {
    let style = 'z-index:1000;';
    if (this.isMobile) {
      style = `height: ${this.listHeight}px; top: ${this.getBottomOfInputWrapper()}px;`;
    } else {
      let tempScrollTarget = null;
      let coords = GetFixedPositionCallback(this.$.inputWrapper, (context, proceed) => {
        const { nextElem } = context;
        const nextElemHasScrollTargetAttribute = nextElem?.hasAttribute('katapult-drop-down-scroll-target');
        const nextElemIsPaperDialogScrollable = nextElem?.tagName === 'PAPER-DIALOG-SCROLLABLE';
        const nextElemIsScrollableDivWithinPaperDialogScrollable =
          nextElem?.__dataHost?.tagName === 'PAPER-DIALOG-SCROLLABLE' && nextElem?.id === 'scrollable';

        if (nextElemHasScrollTargetAttribute || nextElemIsScrollableDivWithinPaperDialogScrollable) tempScrollTarget = nextElem;
        else if (nextElemIsPaperDialogScrollable) tempScrollTarget = nextElem.$.scrollable;

        // Keep traversing up the chain of parents while this statement is true.
        if (
          !nextElem ||
          window.getComputedStyle(nextElem).getPropertyValue('transform') === 'none' ||
          ['PAPER-TABLE', 'KATAPULT-TOOLBAR'].includes(nextElem.tagName)
        )
          proceed();
      });
      this.container = coords.nextElem;

      this.scrollTarget = tempScrollTarget || this.container;

      let containerHeight = this.container.offsetHeight || this.container.innerHeight || 0;
      let containerWidth = this.container.offsetWidth || this.container.innerWidth || 0;
      let difference = containerHeight - coords.y - this.verticalOffset;
      let bottom = difference;
      if (difference < 0 && this.openUpwards) {
        // If the dropdown is going to be off the top of the screen, resize it so it fits.
        if (this.listHeight > containerHeight) this.listHeight = containerHeight - 500;
        const inputWrapper = this.$.inputWrapper;
        const inputWrapperHeight = inputWrapper.getBoundingClientRect()?.height;

        bottom = inputWrapperHeight + this.listHeight;
      } else if (difference < 0 && !this.openUpwards && this.listHeight < containerHeight) {
        this.listHeight = containerHeight - 500;
      }
      if (this.fixedListPosition.width) {
        style += `width: ${this.fixedListPosition.width};`;
      } else {
        style += `min-width: ${this.offsetWidth}px;`;
      }
      if (this.fixedListPosition.height) {
        style += `height: ${this.fixedListPosition.height};`;
      } else {
        style += `height: ${this.listHeight}px;`;
      }
      if (this.fixedListPosition.top) {
        style += `top: ${this.fixedListPosition.top}; bottom:auto;`;
      } else if (this.openUpwards) {
        style += `top: auto; bottom: ${bottom}px;`;
      } else {
        style += `top: ${this.getBoundingClientRect().top + this.offsetHeight + this.verticalOffset}px; bottom: auto;`;
      }

      // If the dropdown is going to be off the right side of the screen, move it in so it is onscreen.
      if (this.fixedListPosition.left) {
        style += `left: ${this.fixedListPosition.left};`;
      } else if (coords.x + this.$.list.offsetWidth > containerWidth - this.margin) {
        style += `right: ${this.margin}px;`;
      } else {
        style += `left: ${coords.x}px;`;
      }

      if (this.fixedListPosition.borderRadius != null) {
        style += `border-radius:${this.fixedListPosition.borderRadius};`;
      }
      if (this.fixedListPosition.zIndex != null) {
        style += `z-index:${this.fixedListPosition.zIndex};`;
      }
    }
    if (!this.isMobile) {
      style += ' position:fixed;';
    }
    this.set('listStyle', style);
  }
  updateFilteredSortedItems() {
    this.sortFilterItemsDebounce = Debouncer.debounce(this.sortFilterItemsDebounce, timeOut.after(10), () => {
      if (!this.opened) {
        this.needToUpdateFilteredSortedItems = true;
      } else {
        this.needToUpdateFilteredSortedItems = false;
        var searchText = String(
          String(this.searchText || '')
            .trim()
            .toLowerCase()
        );
        // Base items are the items before filtered by searchText (but possibly filtered by filter function);
        let baseItems = this.itemsArray;
        if (typeof this.filter === 'function') baseItems = baseItems.filter(this.filter);
        let filteredItems = baseItems;
        if (this.searchText == this.getDefaultSearchText() && this._showAllItems) {
          // Don't filter the list if we just opened the dropdown and search text has not changed
        } else if (typeof this.search === 'function') {
          filteredItems = baseItems.filter((x) => this.search(x, this.searchText));
        } else if (!this.showAllItems) {
          filteredItems = baseItems.filter(
            (item) =>
              this.getLabel(item).toLowerCase().includes(searchText) ||
              (this.secondaryLabelPath && this.getSecondaryLabel(item).toLowerCase().includes(searchText))
          );
          if (this.showLastResults) {
            if (filteredItems.length) this.lastMatchingSearchText = searchText;
            else
              filteredItems = baseItems.filter((item) =>
                this.getLabel(item)
                  .toLowerCase()
                  .includes((this.lastMatchingSearchText || '').toLowerCase())
              );
          }
        }
        // Sort items.
        if (typeof this.sort === 'function') filteredItems.sort(this.sort);
        else {
          // sort alphabetical
          if (this.sortAlphabetically) filteredItems.sort((a, b) => this.getLabel(a).localeCompare(this.getLabel(b)));
          else if (searchText) {
            // sort matches at the beginning of the name
            filteredItems.sort((a, b) => {
              var aStartsWith = this.getLabel(a).toLowerCase().startsWith(searchText);
              var bStartsWith = this.getLabel(b).toLowerCase().startsWith(searchText);
              if (aStartsWith && !bStartsWith) {
                return -1;
              } else if (bStartsWith && !aStartsWith) {
                return 1;
              } else if (this.sortAlphabetically) {
                return this.getLabel(a).localeCompare(this.getLabel(b));
              }
            });
          }
        }
        let scrollTop = 0;
        if (this.opened) {
          scrollTop = this.$.ironList.scrollTop;
        }
        this.set('filteredSortedItems', filteredItems);
        if (scrollTop) {
          this.$.ironList.scrollTop = scrollTop;
        }
        if (!this.secondaryLabelPath) this.ironListItemsHeight = (filteredItems.length || 0) * 48;
        if (this.highlightIndex > filteredItems.length) this.highlightIndex = 0;
      }
    });
  }
  updateSearchText() {
    this.searchText = this.getDefaultSearchText();
  }
  getDefaultSearchText() {
    if (
      this.selectedItem == null &&
      this.value != this.nullValue &&
      (typeof this.value === 'string' || typeof this.value === 'number') &&
      this.showValueAsLabel
    )
      return this.value;
    else {
      this.fullSearchText = this.getLabel(this.selectedItem);
      if (this.displayShortname && this.selectedItem && this.selectedItem.shortname) {
        return this.selectedItem.shortname;
      } else {
        return this.fullSearchText;
      }
    }
  }
  close(e) {
    if (!this.keepOpen) {
      this.opened = this.ignoreNextPopState = this._showAllItems = false;
      this.updateSearchText();
      this.$.input.blur();
    }
  }
  open() {
    if (!this.opened) this.opened = true;
  }
  openedChanged() {
    if (this.opened) {
      this.temporarilyShowAllItems();
      // HACK try to find element with katapult-drop-down-disable-scrolling and disable it's scrolling.
      if (this.isMobile) {
        this.scrollingDisableElements = this.scrollingDisableElements || [];
        if (this.scrollingDisableElements.length == 0) {
          let elem = this;
          while (elem.offsetParent != null && elem.offsetParent instanceof HTMLElement) {
            elem = elem.offsetParent;
            if (elem.hasAttribute('katapult-drop-down-disable-scrolling')) {
              let overflow = getComputedStyle(elem).overflow;
              // Create local scoped variable for element.
              let temp = elem;
              // On IOS, info panel will only show drop-down fully if content is overflowing out of it when scroll region's overflow is set
              // to hidden and then unset. We have no idea why.
              temp.style.overflow = 'hidden';
              setTimeout(() => (temp.style.overflow = 'unset'));
              this.scrollingDisableElements.push({ elem, overflow });
            }
          }
        }
      }

      this.updateListDirection();
      this.updateListStyle();
      window.addEventListener('resize', this.windowResizeHandler, { passive: true });
      if (this.scrollTarget) this.scrollTarget.addEventListener('scroll', this.windowResizeHandler, { passive: true });
      window.addEventListener('mousedown', this.boundClose, { passive: true });
      if (this.isMobile) window.addEventListener('popstate', this.windowPopStateHandler, { passive: true });
    } else {
      if (this.isMobile) {
        (this.scrollingDisableElements || []).forEach((x) => (x.elem.style.overflow = x.overflow));
        this.scrollingDisableElements = [];
      }

      if (this.scrollTarget) this.scrollTarget.removeEventListener('scroll', this.windowResizeHandler);
      window.removeEventListener('resize', this.windowResizeHandler, { passive: true });
      window.removeEventListener('mousedown', this.boundClose, { passive: true });
      if (this.isMobile) window.removeEventListener('popstate', this.windowPopStateHandler, { passive: true });
    }
  }
  temporarilyShowAllItems() {
    this._showAllItems = true;
    this.updateFilteredSortedItems();
  }
  updatePosition() {
    this.updateListDirection();
    this.updateListStyle();
    this.resizeIronList();
  }
  updateListDirection() {
    let space = this.getAvailableSpace();
    if (!this.onlyOpenDown) {
      this.openUpwards = this.ironListItemsHeight > space.below && space.above > space.below;
    }
    this.updateListHeight();
  }
  updateListHeight() {
    let space = this.getAvailableSpace();
    let height = space.below;
    if (this.openUpwards && !this.isMobile) height = space.above;
    height = Clamp(height, 0, this.ironListItemsHeight + this.$.slotContent.offsetHeight + this.$.aboveListSlot.offsetHeight - 1); // Subtract 1 to account for the slotted content border, since offsetHeight does not include the -1px margin
    this.overflow = height < this.ironListItemsHeight;
    this.set('listHeight', height);
  }
  getAvailableSpace(options) {
    options = options || {};
    let above = 0;
    let below = 0;
    let coords = {};
    if (this.fitInto) {
      let parentRect = this.fitInto.getBoundingClientRect();
      let inputRect = this.$.inputWrapper.getBoundingClientRect();
      coords = { x: inputRect.x - parentRect.x, y: inputRect.y - parentRect.y, elem: this.fitInto };
    } else
      coords = GetFixedPosition(this.$.inputWrapper, (elem) => elem.hasAttribute('katapult-drop-down-fit-into') || elem == this.container);
    let containerHeight = coords.elem.offsetHeight || coords.elem.innerHeight || 0;
    let scroll = coords.elem.scrollTop || 0;
    if (this.isMobile) {
      if (this.keyboardVisible) below = Clamp(containerHeight / 2, 0, containerHeight);
      else below = Clamp(containerHeight - this.getBottomOfInputWrapper() - this.margin, 0, containerHeight);
    } else {
      above = Clamp(coords.y - (this.margin + this.headerHeight) - scroll, 0);
      below = Clamp(containerHeight - this.offsetHeight - coords.y - this.margin + scroll, 0);
    }
    return { below, above };
  }
  getBottomOfInputWrapper() {
    return this.$.inputWrapper.offsetTop + this.$.inputWrapper.offsetHeight;
  }
  resetHighlightIndex() {
    if (!this.opened) this.highlightIndex = 0;
  }
  enterPressed(e) {
    this.setSelectedItem(this.get(`filteredSortedItems.${this.highlightIndex}`));
    this.close();
  }
  arrowPressed(e) {
    e.preventDefault();
    e.stopPropagation();

    let dir = e.detail.key === 'up' ? -1 : 1;
    let nextIndex = this.highlightIndex + dir;
    let listLength = (this.get('filteredSortedItems.length') || 1) - 1;

    if (nextIndex > listLength) this.highlightIndex = 0;
    else if (nextIndex < 0) this.highlightIndex = listLength;
    else this.highlightIndex = nextIndex;
  }
  clear(e) {
    // When the value changes, if it is bound to the url (by another element) the dropdown will close.
    // Set this flag to ignore the next popstate event.
    this.ignoreNextPopState = true;
    this.setSelectedItem(null);
    this._valueChanged(); // Call manually so that value gets set to nullValue if _value is already nullValue.
    this.updateSearchText();
    this.focus();
  }
  preventDefault(e) {
    e.preventDefault();
    e.stopPropagation();
  }
}
window.customElements.define(KatapultDropDown.is, KatapultDropDown);
